import { AgResourceLanguage } from '../types';

export const toasts: AgResourceLanguage['toasts'] = {
  useChangeShippingMethod: {
    nextOrderMethodChanged: 'Nächste Bestellung Versandart erfolgreich geändert',
    subscriptionMethodChanged: 'Versandart für das Abonnement wurde erfolgreich geändert'
  },
  commonError: 'Etwas ist schief gelaufen. Bitte versuche es erneut',
  shippingBillingAddress: {
    errorZipCode: 'Geben Sie eine gültige Postleitzahl für {{country}} ein.',
    errorHtmlTag: 'dürfen keine HTML-Tags enthalten.',
    successNextOrder: 'Lieferadresse der nächsten Bestellung wurde erfolgreich geändert',
    successSubscription: ' Lieferadresse des Abonnements wurde erfolgreich geändert',
    successCheckout: 'Lieferadresse wurde erfolgreich geändert'
  },
  changePaymentMethod: {
    cantRemovePaymentMethod: 'Zahlungsmethode kann nicht entfernt werden: falsche customerId',
    removedPaymentMethod: 'Zahlungsmethode wurde erfolgreich entfernt und geändert',
    changedPaymentMethod: 'Zahlungsmethode für das Abonnement wurde erfolgreich geändert',
    incorrectId: 'Ungültige Bestellnummer'
  },
  orderCreated: 'Ordnung entsteht',
  migrationToV53: {
    title: 'Ihr AG1 wurde aktualisiert!',
    description: 'Ihr Abonnement bezieht sich jetzt auf die aktualisierte Version von AG1.'
  }
};
